import styled, { css } from 'styled-components';

import { layout, media, colorUtils } from 'src/components/base';

import {
  Card as CardComponent,
  CardContent as CardContentComponent,
  CardActionArea as CardActionAreaComponent,
  CardBackgroundImage as CardBackgroundImageComponent,
} from '@prisjakt/ui/card';
import { InfoList as InfoListComponent } from 'src/components/info-list';
import { Column } from '@prisjakt/ui/list/variants';
import ContentCardsComponent from '../../areas/expert/components/list-of-content-cards';

export const ContentCards = styled(ContentCardsComponent)`
  ${media.mediumUp`
    display: flex;
  `};
`;

export const Header = styled(Column)`
  && {
    display: none;

    ${media.smallOnly`
      display: flex;
      padding: ${layout.measurements.spacing100};
      padding-bottom: 0;
    `}
  }

  a {
    max-width: max-content;
  }
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(240px, 1fr));
  overflow-x: auto;
  column-gap: ${layout.measurements.spacing100};
  padding: ${layout.measurements.spacing100};

  > * {
    /* Set a white background color to all cards */
    background: ${p => p.theme.bg.primary};
  }

  &::after {
    /* Adds spacing to the end of the scroll area */
    content: '';
    display: block;
    width: ${layout.measurements.spacing100};
    margin-left: -${layout.measurements.spacing100};
    pointer-events: none;
  }

  ${media.mediumUp`
    height: 100%;
  `}
`;

export const AdvizedListWrapper = styled.li<{ grid: boolean }>`
  order: 3;

  ${media.mediumDown`
    order: 2;
  `}

  ${media.smallOnly`
    grid-area: 4 / 1 / auto / -1;
    display: grid;
    background: ${p => p.theme.colors.maybeBlue100};
    margin: ${layout.measurements.spacing050} -${
    layout.measurements.spacing050
  };
  `}

  ${props =>
    !props.grid &&
    css`
      min-width: 25%;
      flex: 1 1 25%;

      @media screen and (max-width: 820px) and (min-width: 520px) {
        min-width: 33%;
        flex: 1 1 33%;
        order: 2 !important;
      }

      @media screen and (max-width: 520px) {
        min-width: 50%;
        flex: 1 1 50%;
        order: 1 !important;
      }
    `}
`;

export const Wrapper = styled.div`
  ${media.mediumUp`
      margin-bottom: ${layout.measurements.spacing200};

      ${Cards} {
        grid-template-columns: repeat(6, minmax(235px, 1fr));
        padding: ${layout.measurements.spacing050};
      }

      ${Header} {
        display: flex;
        padding: ${layout.measurements.spacing050};
        padding-bottom: 0;
      }
  `}

  ${media.largeUp`
    ${Cards} {
      overflow-x: hidden;
    }
  `}
`;

export const Card = styled(CardComponent)`
  height: 100%;
  background: ${p => p.theme.bg.primary};
`;

export const CardBackgroundImage = styled(CardBackgroundImageComponent)`
  background-position: center center;
  flex: 1 0 auto;
`;

export const PreTitle = styled.span`
  font-size: ${layout.measurements.fontSizeMedium};
  font-weight: bold;
  line-height: 1.25;
  color: ${p => colorUtils.setRgbaAlpha(p.theme.colors.base0, 0.72)};
`;

export const Title = styled.span`
  font-size: ${layout.measurements.fontSizeLarge};
  font-weight: 800;
  line-height: 1.5;
  text-transform: uppercase;
`;

export const CardContent = styled(CardContentComponent)`
  display: grid;
  grid-row-gap: ${layout.measurements.spacing050};

  ${PreTitle} {
    margin-bottom: 0;
  }
`;

export const CardActionArea = styled(CardActionAreaComponent)`
  flex: 1 0 auto;
`;

export const Description = styled.div`
  font-size: ${layout.measurements.fontSizeMedium};
  font-weight: bold;
  line-height: 1.25;
`;

export const InfoList = styled(InfoListComponent)`
  margin-top: ${layout.measurements.spacing100};
  color: ${p => p.theme.colors.staticBase0};
`;
